var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayor = function SvgPayor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4023 4C11.5614 3.99973 11.7144 4.06245 11.8271 4.17481C11.9397 4.28733 12.0039 4.44041 12.0039 4.59961V10.4375C12.0035 10.7685 11.7344 11.037 11.4033 11.0371C11.0723 11.0369 10.804 10.7685 10.8037 10.4375V6.04492L5.02339 11.8252C4.78929 12.059 4.41001 12.0587 4.17574 11.8252C3.94143 11.5909 3.94142 11.2109 4.17574 10.9766L9.95015 5.20117L5.57808 5.21094C5.247 5.21148 4.97846 4.94334 4.97749 4.61231C4.97685 4.28094 5.24476 4.01139 5.57613 4.01074L11.4023 4Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "payor.c8c1d12ac4a0bf2e2aa1ca297af82d9a.svg";